import $ from 'jquery'
import debounce from './debounce'

async function tradeCounterCheckout () {
  $(loadCheckoutDetails)

  $(document).on(
    'input change keyup',
    '.trade-counter-checkout input',
    debounce(storeCheckoutDetails, 250)
  )

  $(document).on('click', 'input[name=trade_counter]', tradeCounterClicked)

  const storage = sessionStorage

  const keys = ['name', 'company', 'postcode', 'email', 'phone_number', 'auth']

  let cleared = false

  function loadCheckoutDetails () {
    if (!$('.trade-counter-checkout').length) {
      return
    }
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i]
      input(key).val(storage.getItem('tccd-' + key))
    }
  }

  function storeCheckoutDetails () {
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i]
      storage.setItem('tccd-' + key, input(key).val())
    }
  }

  function tradeCounterClicked (event) {
    const name = document.getElementById('tc_name').value
    const company = document.getElementById('tc_company').value
    if (name === '' && company === '') {
      event.preventDefault()
      alert('Either a name or company is required')
      return false
    }

    const email = document.getElementById('tc_email').value
    if (email === '') {
      event.preventDefault()
      alert('Email is required')
      return false
    }

    const phoneNumber = document.getElementById('tc_phone_number').value
    if (phoneNumber === '') {
      event.preventDefault()
      alert('Phone number is required')
      return false
    }

    clearCheckoutDetails(event)
  }

  function clearCheckoutDetails (event) {
    if (cleared) {
      return
    }

    // Prevent form submission this time.
    event.preventDefault()

    // Clear details.
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i]
      storage.removeItem('tccd-' + key)
    }

    // Set cleared flag so we don't run again; re-click original button.
    cleared = true
    event.target.click()
  }

  function input (key) {
    const sel = '.trade-counter-checkout input[name=' + key + ']'
    return $(sel)
  }

  // Initialise address finder
  const addressLine1 = document.getElementById('tc_address_line_1')

  if (!addressLine1) {
    return
  }

  function getAddressField (fieldName) {
    return document.getElementById(`${fieldName}`)
  }

  // This makes a difference to bundle size. We won't request it on pages that don't use it.
  const { AddressFinder } = await import('@ideal-postcodes/address-finder')

  AddressFinder.setup({
    inputField: addressLine1,
    apiKey: 'ak_kpe4kyc8ygEj9ON4fAstKJMTE7T0V',
    outputFields: {
      line_1: addressLine1,
      line_2: getAddressField('tc_address_line_2'),
      line_3: getAddressField('tc_address_line_3'),
      post_town: getAddressField('tc_town_city'),
      postcode: getAddressField('tc_postcode'),
      county: getAddressField('tc_county')
    }
  })
}

export default tradeCounterCheckout
